export default __webpack_public_path__ + "static/icon-7-3-e9125ef50831191d211fd0bd608008c3.png";